import { Button, Label } from '@blueprintjs/core';
import FiscalYearSelect from 'Components/Generic/BOSFilterSelect/FiscalYearSelect';
import { useGlobalState } from 'Data/context/GlobalState';
import { OPEN_FISCAL_YEARS } from 'Util/dateUtil';
import styles from './Configuration.module.css';

const YearConfig = () => {
  const [globalState, _, setFiscalYear] = useGlobalState();

  return (
    <div>
      <div className={styles.option_box}>
        <Label className={styles.options_label}>Fiscal year:</Label>
        <div className={styles.year_selection_box}>
          <FiscalYearSelect
            onSelectFiscalYear={({ year }) =>
              setFiscalYear(
                !year || year === '-'
                  ? null
                  : year === 'All Open Fiscal Years'
                  ? OPEN_FISCAL_YEARS
                  : [year],
              )
            }
            defaultSelectedYear={
              globalState.fiscalYear === OPEN_FISCAL_YEARS
                ? 'Open Fiscal Years'
                : globalState.fiscalYear?.length
                ? `${globalState.fiscalYear}`
                : '-'
            }
            additionalListItems={[
              '-',
              ...(new Date().getMonth() > 5 && new Date().getMonth() <= 6
                ? ['All Open Fiscal Years']
                : []),
            ]}
            numberOfYearsToShow={20}
            autoMarginLeft
            fill
            matchWidth
          />
          {globalState.fiscalYear?.length && (
            <Button
              className={styles.clear_button}
              minimal
              onClick={() => setFiscalYear(null)}>
              Clear
            </Button>
          )}
        </div>
        <Label className={styles.sub_label}>
          {globalState.fiscalYear?.length
            ? `(BOS will only show orders and transactions from fiscal year${
                globalState.fiscalYear?.length > 1 ? 's' : ''
              }: ${globalState.fiscalYear.join(', ')})`
            : '(BOS will not filter orders and transactions by fiscal year.)'}
        </Label>
      </div>
    </div>
  );
};

export default YearConfig;
